module.exports = __webpack_public_path__ + "static/media/welcome_screen_image.fa68d2ad.png";